<template>
  <div
    class="gift"
    :class="[theme ? 'gift--theme-' + theme : null ]"
  >
    <div class="gift__left">
      <div class="gift__pic gift-ticket" />

      <div class="gift__pictos">
        <div class="gift__picto gift__picto--coin">
          <div class="gift-coin" />
        </div>

        <div class="gift__picto gift__picto--ticket">
          <PictoTicket />
        </div>
      </div>
    </div>

    <div class="gift__right">
      <p
        class="gift__small"
        v-html="$store.state.config.common.gift.header"
      />

      <p
        class="gift__text"
        v-html="$store.state.config.common.gift.body"
      />

      <p
        class="gift__small"
        v-html="$store.state.config.common.gift.footer"
      />
    </div>
  </div>
</template>

<script>
import PictoTicket from '@/components/pictos/PictoTicket.vue';

export default {
  components: { PictoTicket },

  props: {
    theme: { type: String, default: null },
  },
};
</script>

<style lang="stylus" scoped>
.gift {
  background-color: $cl-white;

  +above('xl') {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }

  &--theme-green { color: $cl-green; }
  &--theme-purple { color: $cl-purple; }
  &--theme-orange { color: $cl-orange; }
}

.gift__left {
  position: relative;
  height: 90px;

  +above('xl') {
    flex-shrink: 0;
    width: 35%;
    height: auto;
  }
}

.gift__right {
  flex-grow: 1;
  padding: 40px 20px 20px 30px;

  +above('xl') {
    padding-top: 20px;
    align-self: center;
  }
}

.gift__pic {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center 52%;

  +above('xl') {
    background-position: center;
  }
}
.gift__text {
  @extend $typo-product-gift;
  text-align: left;
  margin: 10px 0;

  >>> b {
    @extend $typo-product-gift;
    font-weight: 700;
  }
}

.gift__small {
  @extend $typo-product-gift-small;
  text-align: left;
  margin: 0;
}

.gift__picto {
  position: absolute;
  left: 10px;
  width: 50px;
  height: 50px;

  +above('xl') {
    right: 0px;
    left: auto;
  }

  &--coin {
    bottom: -25px;

    +above('xl') {
      bottom: 50%;
      transform: translate(30%, 10%);
    }
  }

  &--ticket {
    bottom: -25px;
    transform: translate(80%, 0) rotate(-30deg);

    +above('xl') {
      bottom: auto;
      top: 50%;
      transform: translate(30%, -10%) rotate(-30deg);
    }

    display: flex;
    justify-content: center;
    padding: 10px;

    background-color: $cl-white;
    border: 1px solid currentColor;
    border-radius: 25px;

    svg {
      width: 100%;
      fill: currentColor;
    }
  }
}
</style>
